import React, { useEffect, useState } from "react";

function HelloWorld() {
  const [message, setMessage] = useState("Loading...");

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    console.log("Token:", token);

    if (token) {
      window.location.href = "/dashboard";
    } else {
      window.location.href = "/login";
    }
  }, []);

  return <h1>{message}</h1>;
}

export default HelloWorld;
